import { Query } from '@cubejs-client/core';
import React from 'react';
import { CardGraphBase } from '../CardGraphBase';

export default class ForfeitPaymentVolumeCard extends CardGraphBase {
  graphName() { return ''; }

  graphSubtitle() {
    return 'Volume of forfeit fees';
  }

  processValue(value) {
    return `$${super.processValue(Number(value).toFixed(0))}`;
  }


  query(): Query {
    return {
      measures: [
        'FctGeneral.totalForfeitPaymentsInDollars',
      ],
      timeDimensions: [
        {
          dimension: 'FctGeneral.dateDay',
          dateRange: this.props?.timePeriod,
        },
      ],
      order: {},
      filters: [
        {
          dimension: 'FctGeneral.organisationId',
          operator: 'equals',
          values: [
            this.props.organisationId,
          ],
        },
        // {
        //   dimension: 'FctGeneral.competitionId',
        //   operator: 'equals',
        //   values: [
        //     this.props.competitionId,
        //   ],
        // },
      ],
    };
  }

  // render() {
  //     return <p>This graph might not really be possible</p>
  // }
}
